<template>
  <div></div>
</template>
<script>
import { POINT_MARKER_ICON_CONFIG } from "../../utils/mapSettings";

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
    floating: {
      type: Boolean,
      required: false,
    },
    nearestLocation: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      point: null,
    };
  },

  watch: {
    nearestLocation(newValue, oldValue) {
      var newLatLng = new this.google.maps.LatLng(
        newValue.position.lat,
        newValue.position.lng
      );
      this.point.setPosition(newLatLng);
    },
  },

  computed: {
    isFloatingActive() {
      return this.floating
        ? POINT_MARKER_ICON_CONFIG
        : {
            path: this.google.maps.SymbolPath.CIRCLE,
            scale: 0,
          };
    },
  },

  mounted() {
    this.point = new this.google.maps.Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      icon: this.isFloatingActive,
    });
  },
  methods: {
    clearPoint() {
      this.point.setMap(null);
    },
  },
};
</script>
